import { useState } from 'react';
import './App.css';

const buttons = [
  ['C', '+/-', '%', '÷'],
  ['7', '8', '9', '×'],
  ['4', '5', '6', '−'],
  ['1', '2', '3', '+'],
  ['0', '.', '='],
];

export default function App() {
  const [display, setDisplay] = useState('0');
  const [prev, setPrev] = useState(null);
  const [operator, setOperator] = useState(null);
  const [waitingForOperand, setWaitingForOperand] = useState(false);

  const calculate = (a, b, op) => {
    switch (op) {
      case '+': return a + b;
      case '−': return a - b;
      case '×': return a * b;
      case '÷': return b !== 0 ? a / b : 'Error';
      default: return b;
    }
  };

  const handleNumber = (num) => {
    if (waitingForOperand) {
      setDisplay(String(num));
      setWaitingForOperand(false);
    } else {
      setDisplay(display === '0' ? String(num) : display + num);
    }
  };

  const handleDecimal = () => {
    if (waitingForOperand) {
      setDisplay('0.');
      setWaitingForOperand(false);
      return;
    }
    if (!display.includes('.')) setDisplay(display + '.');
  };

  const handleOperator = (op) => {
    const current = parseFloat(display);
    if (prev !== null && !waitingForOperand) {
      const result = calculate(prev, current, operator);
      setDisplay(String(result));
      setPrev(result);
    } else {
      setPrev(current);
    }
    setOperator(op);
    setWaitingForOperand(true);
  };

  const handleEqual = () => {
    if (operator === null || prev === null) return;
    const current = parseFloat(display);
    const result = calculate(prev, current, operator);
    setDisplay(String(result));
    setPrev(null);
    setOperator(null);
    setWaitingForOperand(true);
  };

  const handleClear = () => {
    setDisplay('0');
    setPrev(null);
    setOperator(null);
    setWaitingForOperand(false);
  };

  const handlePlusMinus = () => setDisplay(String(parseFloat(display) * -1));
  const handlePercent = () => setDisplay(String(parseFloat(display) / 100));

  const handleClick = (btn) => {
    if (btn === 'C') return handleClear();
    if (btn === '+/-') return handlePlusMinus();
    if (btn === '%') return handlePercent();
    if (btn === '.') return handleDecimal();
    if (btn === '=') return handleEqual();
    if (['+', '−', '×', '÷'].includes(btn)) return handleOperator(btn);
    handleNumber(btn);
  };

  return (
    <div className="calculator">
      <div className="display">{display}</div>
      <div className="buttons">
        {buttons.map((row, i) => (
          <div key={i} className="row">
            {row.map((btn) => (
              <button
                key={btn}
                className={`btn ${['C', '+/-', '%'].includes(btn) ? 'btn-gray' : ''} ${['+', '−', '×', '÷', '='].includes(btn) ? 'btn-orange' : ''} ${btn === '0' ? 'btn-wide' : ''}`}
                onClick={() => handleClick(btn)}
              >
                {btn}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
